import React, { useState, useEffect } from "react";
import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import "./TitleWithSearch.css";
import NewButton from "../../NewComponents/NewButton";

const TeamTitleWithSearch = ({
  title,
  onSearch,
  placeholder,
  onAddMemberClick,
  onCreateTeamClick,
  showCreateBtn = false,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    // if (searchQuery.length > 3) {
    //   const timer = setTimeout(() => {
    //     onSearch(searchQuery);
    //   }, 1000);

    //   return () => clearTimeout(timer);
    // } else {
    //   onSearch("");
    // }
    onSearch(searchQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  return (
    <div className="TitleWithSearchBox lg:flex-row flex-col">
      <h2 className="MainTitle">{title}</h2>

      <div className="lg:w-fit w-full grid lg:grid-cols-2 grid-cols-1 gap-4">
        <label className="SearchBox md:w-fit !w-full">
          <SEARCHICON className="SearchIcon" />
          <input
            className="SearchInput"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </label>
        <div className={`w-full grid ${!showCreateBtn ? "grid-cols-1": "grid-cols-2"} gap-2 items-center`}>
          {showCreateBtn && (
            <NewButton
              text="Create Team"
              onClick={onCreateTeamClick}
              icon={false}
              width="100%"
            />
          )}

          <NewButton
            text="Add Member"
            onClick={onAddMemberClick}
            back
            icon={false}
            whiteBtn
            // width="150px"
            width="100%"
          />
        </div>
      </div>
    </div>
  );
};

export default TeamTitleWithSearch;
